export enum ProfileResponseType {
  Redirect = 1,
  Routed = 2,
  Targeted = 3
}
